import { ACCENT, SURFACE, TEXT } from "../../dark-theme/palette";

/** Site puzzle chrome — always the current season tokens. */
export const SITE_NAV_THEME = {
    paper: SURFACE.chrome,
    header: SURFACE.card,
    border: SURFACE.border,
    hover: SURFACE.hover,
    text: TEXT.primary,
    textMuted: TEXT.secondary,
    activeBg: ACCENT.soft,
    activeBorder: ACCENT.main,
    activeHoverBorder: ACCENT.light,
    activeText: ACCENT.light,
    hoverShadow: "0 2px 8px rgba(0,0,0,0.1)",
    activeShadow: "0 1px 4px rgba(0,0,0,0.1)",
};

/** Tutors hub drawer in light mode (classroom / worksheet look). */
export const TUTORS_NAV_LIGHT = {
    paper: "#ffffff",
    header: "#f1f5f9",
    border: "rgba(15, 23, 42, 0.12)",
    hover: "rgba(15, 23, 42, 0.06)",
    text: "#0f172a",
    textMuted: "#475569",
    activeBg: "rgba(59, 166, 102, 0.14)",
    activeBorder: ACCENT.main,
    activeHoverBorder: ACCENT.dark,
    activeText: ACCENT.dark,
    hoverShadow: "0 2px 8px rgba(15, 23, 42, 0.08)",
    activeShadow: "0 1px 4px rgba(15, 23, 42, 0.08)",
};

/** Tutors hub drawer in dark mode — same tokens as the rest of the site. */
export const TUTORS_NAV_DARK = SITE_NAV_THEME;

export function getNavDrawerTheme({ tutorsHub, prefersDark }) {
    if (!tutorsHub) {
        return SITE_NAV_THEME;
    }
    return prefersDark ? TUTORS_NAV_DARK : TUTORS_NAV_LIGHT;
}
